<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Zameni rezervacije</b></div>
            </div>              
            <!-- Switch reservations -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-reservation-switch">Zameni ovu rezervaciju sa drugim stolom</label>
                <select class="c-form-control" id="guest-reservation-switch" name="guest-reservation-switch" v-model="formVars.selectedReservationForSwap.model">
                  <option v-bind:value="null">Izaberi sto za zamenu..</option>
                  <option
                    v-for="(singleReservationTable, key) in listOfAllTables"
                    v-bind:value="singleReservationTable"
                    v-if="calculateIfTableIsAvailableForSwap(singleReservationTable)"
                  ><span v-if="singleReservationTable.tableShortName">{{singleReservationTable.tableShortName}}</span><span v-if="singleReservationTable.tableNumber">{{singleReservationTable.tableNumber}}</span></option>
                </select>
              </div>
            </div>
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Zameni rezervacije</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>

import router from '@/router/index'
import EventBus from '@/EventBus'
import moment from 'moment'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalQuickSwapReservations',
  props: ['inputModalData'],
  data () {
    return {
      msg: 'ModalQuickSwapReservations modal',
      resolve: null,
      reject: null,
      ///
      selectedReservationObject: null,
      // ~ received object of event that we want to show
      eventReservationsKey: null,
      ///
      listOfAllTables: null,
      formVars: {
        isValid: false,
        selectedReservationForSwap: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }
      }
    }
  },
  watch: {
    'formVars.selectedReservationForSwap.model' : function (newValue){
      //console.log('formVars.selectedReservationForSwap.model changed to: ' + newValue);
    }
  },
  methods: {
    deepCopy: function (inputData){
      var clonedData = JSON.parse(JSON.stringify(inputData))
      return clonedData;
    },    
    getAllReservations: function () {
      //console.log('Swap get url: listOfAllEventsReservations/' + this.eventReservationsKey + '/' + this.selectedReservationObject.uid);
      var allTablesRef = firebaseDB.ref('listOfAllEventsReservations/' + this.eventReservationsKey).once('value').then(
        function(snapshot) {
        //console.log('Get All Reservations Success');
        //console.log('snapshot: ' + snapshot.val());
        this.listOfAllTables = snapshot.val();
        //console.log('-----------------------------------');
        //console.log('##### snapshot: ' + JSON.stringify(snapshot.val(), null, 2));
      }.bind(this), function(error) {
        console.log('Get All Reservations Error');
      }.bind(this));   
    },
    ////
    calculateIfTableIsAvailableForSwap: function (inputTableObject) {
      var returnValue = true;
      if (inputTableObject && inputTableObject.tableLocked && inputTableObject.tableLocked.status && inputTableObject.tableLocked.status == true){
        returnValue = false;
      }
      if (inputTableObject.uid == this.selectedReservationObject.uid){
        returnValue = false;
      }
      //
      return returnValue;
    },
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      if (this.formVars.selectedReservationForSwap.model){
        var thisTableObject = this.deepCopy( this.selectedReservationObject);
        //console.log('thisTableObject: ' + JSON.stringify(thisTableObject, null, 2) );
        var tableToSwapWithObject = this.deepCopy(this.formVars.selectedReservationForSwap.model);
        //console.log('tableToSwapWithObject: ' + JSON.stringify(tableToSwapWithObject, null, 2) );
        firebaseDB.ref().child('/listOfAllEventsReservations/' + this.eventReservationsKey + '/' + tableToSwapWithObject.uid).update({
          guestFirstName: (thisTableObject.guestFirstName) ? thisTableObject.guestFirstName : null,
          guestLastName: (thisTableObject.guestLastName) ? thisTableObject.guestLastName : null,
          guestNickname: (thisTableObject.guestNickname) ? thisTableObject.guestNickname : null,
          guestPhone: (thisTableObject.guestPhone) ? thisTableObject.guestPhone : null,
          guestSocialLink: (thisTableObject.guestSocialLink) ? thisTableObject.guestSocialLink : null,
          regularGuestKey: (thisTableObject.regularGuestKey) ? thisTableObject.regularGuestKey : null
        }).then(
          function (response) {
            //console.log('Modal Quick Swap 01 succ: ' + JSON.stringify(response, null, 2));
            firebaseDB.ref().child('/listOfAllEventsReservations/' + this.eventReservationsKey + '/' + thisTableObject.uid).update({
              guestFirstName: (tableToSwapWithObject.guestFirstName) ? tableToSwapWithObject.guestFirstName : null,
              guestLastName: (tableToSwapWithObject.guestLastName) ? tableToSwapWithObject.guestLastName : null,
              guestNickname: (tableToSwapWithObject.guestNickname) ? tableToSwapWithObject.guestNickname : null,
              guestPhone: (tableToSwapWithObject.guestPhone) ? tableToSwapWithObject.guestPhone : null,
              guestSocialLink: (tableToSwapWithObject.guestSocialLink) ? tableToSwapWithObject.guestSocialLink : null,
              regularGuestKey: (tableToSwapWithObject.regularGuestKey) ? tableToSwapWithObject.regularGuestKey : null
            }).then(
              function (response) {
                //console.log('Modal Quick Swap 02 succ: ' + JSON.stringify(response, null, 2));
                var resultToReturn = {
                  tempMsg: 'ModalQuickSwapReservations returns Yes'
                }
                this.resolve(resultToReturn);
              }.bind(this),
              function (error){
                console.log('Modal Quick Swap 02 ERROR: ' + JSON.stringify(error, null, 2));
              }.bind(this)
            );            
          }.bind(this),
          function (error){
            console.log('Modal Quick Swap 01 ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      }
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    },
  },
  created () {
    //console.log('~ created- ModalQuickSwapReservations component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedReservationItem){
        this.selectedReservationObject = this.inputModalData.dataForModal.selectedReservationItem;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.eventReservationsKey){
        this.eventReservationsKey = this.inputModalData.dataForModal.eventReservationsKey;
        this.getAllReservations();
      }
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalQuickSwapReservations component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalQuickSwapReservations component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/ModalQuickSwapReservations.vue